import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupSettingsForm } from '../forms/GroupSettingsForm';

type GroupSettingsModalProps = {
  isOpen: boolean;
  groupUuid: string;
  onClose: () => void;
};

export const GroupSettingsModal = ({ isOpen, groupUuid, onClose }: GroupSettingsModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal title={t('groups.groupSettings')} isOpen={isOpen} loading={loading} onRequestClose={onClose} width='s'>
      <Suspense fallback={<LazyLoader embedded forceHeight='8vh' />}>
        <GroupSettingsForm onLoad={setLoading} onClose={onClose} groupUuid={groupUuid} />
      </Suspense>
    </Modal>
  );
};
